import isPropValid from '@emotion/is-prop-valid';
const propValidationCache = new Map();
/** Shim between styled-components v5 and v6 */
export const shouldForwardStyledProp = (propName, target) => {
    if (typeof target !== 'string') {
        return true;
    }
    if (propName === 'as' || propName === 'forwardedAs') {
        return true;
    }
    if (propName.startsWith('$')) {
        return false;
    }
    if (propName.startsWith('data-') || propName.startsWith('aria-')) {
        return true;
    }
    const cacheKey = `${target}:${propName}`;
    const fromCache = propValidationCache.get(cacheKey);
    if (fromCache !== undefined) {
        return fromCache;
    }
    const isValid = isPropValid(propName);
    propValidationCache.set(cacheKey, isValid);
    return isValid;
};
